import PromoBanner from "@/components/PromoBanner";
import type { PromoBannerProps } from "@/components/PromoBanner/types";

export default function SearchHitsPromoBanner({
  data,
  position,
  level,
}: {
  data: PromoBannerProps;
  position: number;
  level?: string;
}) {
  const { variant } = data;
  if (!variant) {
    return null;
  }
  switch (variant) {
    case "card":
      if (position === 0) {
        return <PromoBanner {...data} className="flex lg:hidden xl:hidden" />;
      }
      if (position === 1) {
        return <PromoBanner {...data} className="hidden lg:flex xl:hidden" />;
      }
      // always display after third result
      if (position === 2) {
        return <PromoBanner {...data} className="hidden xl:flex" />;
      }
      return null;
    case "compact":
      // first level results places this banner outside of hits container, don't display it there
      if (level === "second") {
        // adjust placement of banner based on screen size to avoid weird line breaks
        if (position === 0) {
          return <PromoBanner {...data} className="md:hidden" />;
        }
        if (position === 1) {
          return (
            <PromoBanner
              {...data}
              className={`col-span-2 hidden md:flex lg:hidden xl:hidden`}
            />
          );
        }
        if (position === 2) {
          return (
            <PromoBanner
              {...data}
              className={`col-span-3 hidden lg:flex xl:hidden`}
            />
          );
        }
        if (position === 3) {
          return (
            <PromoBanner {...data} className="col-span-4 hidden xl:flex" />
          );
        }
      }
      return null;
    case "split":
      if (position === 1) {
        // in second level results, should only take up one column on mobile; otherwise, take up two columns
        return (
          <PromoBanner
            {...data}
            variant="split"
            className={`xl:col-span-2 ${level === "second" ? "max-w-[330px] md:hidden xl:max-w-full xl:flex xl:h-[332px]" : "min-w-[520px] lg:min-w-auto"}`}
          />
        );
      }
      if (position === 0 && level === "second") {
        return (
          <PromoBanner
            {...data}
            className={`col-span-1 lg:flex lg:col-span-2 xl:hidden `}
          />
        );
      }
      if (position === 1 && level === "second") {
        return (
          <PromoBanner
            {...data}
            className={`hidden md:flex xl:hidden col-span-2 lg:col-span-1`}
          />
        );
      }
      return null;
    default:
      return null;
  }
}
